import { Box, Link, useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import * as config from "../../../config/config";
import { sendTrackingEvent } from "../../../helpers/tracking_management";
import { fetchPaidPartnershipPageContent } from "../../../redux/actions/company_action";
import { SectionContainer, TextStyled } from "./styles";

let query = `
  firstSectionTitle
  featuredProgram{
    coverImage{
      data {
        attributes {
          url
        }
      }
    }
      jobTitle
      companyName 
      companyLogo{
        data {
          attributes {
            url
          }
        }
      }
    expiryDate
    jobLink
    tagHot
    tagJobType
    tagLocation
    tagYearsOfExperience 
  }
  `;

function LandingFeaturedJobs(props) {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  async function fetchData() {
    const response = await dispatch(fetchPaidPartnershipPageContent(query));

    const { featuredProgram, firstSectionTitle } = response || {};
    const now = Date.now();
    const filteredFeaturedProgram = (featuredProgram || []).filter((job) => {
      if (!job?.expiryDate) return true;
      const expiryTime = new Date(job.expiryDate).getTime();
      if (Number.isNaN(expiryTime)) return true;
      return expiryTime >= now;
    });

    setData({ featuredProgram, firstSectionTitle });
    setJobs(filteredFeaturedProgram);
    setLoading(false);
  }

  useEffect(() => {
    fetchData();
  }, []);

  // useEffect(() => {
  //   async function fetchJobs() {
  //     try {
  //       const pagination = {
  //         first: 30,
  //         last: null,
  //         startCursor: null,
  //         endCursor: null,
  //       };

  //       // Management Trainee jobs → trackId 23
  //       const jobParams = formJobQueryParam({ specialisation: [23] }, false);
  //       const result = await getJobsWithoutRedux(jobParams, pagination);

  //       const jobNodes = result?.jobs || [];
  //       setJobs(jobNodes);
  //     } catch (e) {
  //       // fail silently for now, just show empty
  //       setJobs([]);
  //     } finally {
  //       setLoading(false);
  //     }
  //   }

  //   fetchJobs();
  // }, [dispatch]);

  return (
    <SectionContainer
      aria-label="Management trainee jobs"
      id="LandingFeaturedJobs"
    >
      {loading ? (
        <Box sx={{ marginTop: "24px" }}>
          <TextStyled variant="body2">Loading jobs…</TextStyled>
        </Box>
      ) : jobs.length === 0 ? (
        <Box sx={{ marginTop: "24px" }}>
          <TextStyled variant="body2">
            {t?.("companydetail.no_jobs_available") ??
              "No jobs available right now."}
          </TextStyled>
        </Box>
      ) : (
        <Box
          sx={{
            width: "100%",
            maxWidth: "1240px",
            margin: "0px",
            display: "grid",
            gridTemplateColumns: {
              xs: "repeat(1, minmax(0, 1fr))",
              md: "repeat(2, minmax(0, 1fr))",
              lg: "repeat(3, minmax(0, 1fr))",
            },
            columnGap: { xs: "16px", md: "24px", lg: "40px" },
            rowGap: { xs: "24px", md: "24px", lg: "40px" },
            justifyContent: "stretch",
          }}
        >
          {jobs?.map((job, index) => (
            <CompanyFeaturedJobCard key={job.id} job={job} index={index} />
          ))}
        </Box>
      )}
    </SectionContainer>
  );
}

//render company job card
export function CompanyFeaturedJobCard(props) {
  const { job } = props;
  const { t } = useTranslation();
  const isMobile = useMediaQuery("(max-width: 640px)");

  const getJobTypeLabel = (jobType) => {
    if (jobType == "full_time") return "Full-time";
    if (jobType == "part_time") return "Part-time";
    if (jobType == "freelance") return "Freelance";
    if (jobType == "internship") return "Internship";
    return jobType;
  };

  const getWorkExperienceLabel = (workExperience) => {
    if (workExperience == "Exp_1_to_3_Years")
      return t(
        "userprofile.job_alerts_create_dialog.experience_labels.1_to_3_years_of_experience"
      );
    if (workExperience == "Exp_4_to_7_Years")
      return t(
        "userprofile.job_alerts_create_dialog.experience_labels.4_to_7_years_of_experience"
      );
    if (workExperience == "Exp_8_to_10_Years")
      return t(
        "userprofile.job_alerts_create_dialog.experience_labels.8_to_10_years_of_experience"
      );
    if (workExperience == "Over_10_Years")
      return t(
        "userprofile.job_alerts_create_dialog.experience_labels.over_10_years_of_experience"
      );
  };

  const title = job?.jobTitle || "";
  const companyName = job?.companyName || "";

  const bannerSrc =
    job?.coverImage?.data?.attributes?.url ||
    config.assetDomain +
      "/images/backgrounds/hiredly-jobs-malaysia-wobb-background-v1.png";
  const logoSrc =
    job?.companyLogo?.data?.attributes?.url ||
    config.assetDomain +
      "/images/backgrounds/hiredly-jobs-malaysia-wobb-background-v1.png";

  const chipItems = [];
  if (job?.tagHot) {
    chipItems.push({
      key: "hot",
      label: t("companydetail.hot") || "Trending",
      bg: "rgba(81, 42, 204, 0.14)",
      color: "#512ACC",
    });
  }
  if (job?.tagJobType) {
    chipItems.push({
      key: "jobType",
      label: getJobTypeLabel(job?.tagJobType),
      bg: "rgba(33, 61, 181, 0.14)",
      color: "rgba(81, 42, 204, 1)",
    });
  }
  if (job?.tagLocation) {
    chipItems.push({
      key: "location",
      label: job?.tagLocation,
      bg: "rgba(81, 42, 204, 0.14)",
      color: "rgba(81, 42, 204, 1)",
    });
  }
  if (job?.tagYearsOfExperience) {
    chipItems.push({
      key: "experience",
      label: getWorkExperienceLabel(job?.tagYearsOfExperience),
      bg: "rgba(242, 175, 41, 0.14)",
      color: "#C0840C",
    });
  }

  function handleEventJobCard(event, jobLink) {
    sendTrackingEvent({
      event: "CE_job-click",
      origin: "paid_partnership_page",
      section: "featured_jobs",
      // job_link: jobLink,
    });
  }

  return (
    <Box
      component={Link}
      onClick={(event) => handleEventJobCard(event, job?.jobLink)}
      href={job?.jobLink}
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        width: "100%",
        maxWidth: { xs: "100%", lg: "100%" },
        minHeight: 309,
        background: "white",
        boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.16)",
        borderRadius: "10px",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        textDecoration: "none",
      }}
    >
      <Box
        sx={{
          width: "100%",
          minHeight: "unset",
          height: "100%",
          background: "#000",
          overflow: "hidden",
          borderRadius: "10px",
          position: "relative",
        }}
      >
        <Box
          component="img"
          src={bannerSrc}
          alt={job?.jobTitle || "featured program"}
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center",
            maxHeight: isMobile ? "317px" : "224px",
          }}
        />

        <Box
          component="img"
          src={logoSrc}
          alt={job?.companyName || "company logo"}
          sx={{
            position: "absolute",
            bottom: "-5px",
            right: "-5px",
            zIndex: 1,
            background: "white",
            border: "5px solid white",
            borderRadius: "0.625rem 0 0 0",
            width: "90px",
            height: "90px",
            objectFit: "contain",
          }}
        />
      </Box>

      <Box
        sx={{
          width: "100%",
          flex: 1,
          padding: "16px 8px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "flex-start",
          gap: "8px",
        }}
      >
        <Box
          sx={{
            alignSelf: "stretch",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: "20px",
            width: "100%",
            height: "100%",
          }}
        >
          <Box
            sx={{
              alignSelf: "stretch",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              gap: "2px",
            }}
          >
            <Box
              sx={{
                alignSelf: "stretch",
                color: "#000",
                fontSize: "16px",
                fontFamily: "Inter",
                fontWeight: 700,
                lineHeight: "24px",
                letterSpacing: "0.1px",
                wordWrap: "break-word",
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }}
            >
              {title}
            </Box>
            <Box
              sx={{
                color: "#000",
                fontSize: "14px",
                fontFamily: "Inter",
                fontWeight: 400,
                lineHeight: "20px",
                wordWrap: "break-word",
                display: "-webkit-box",
                WebkitLineClamp: 1,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }}
            >
              {companyName}
            </Box>
          </Box>

          {/* chips */}
          {chipItems.length > 0 && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                gap: "6px",
                width: "100%",
                flexWrap: "wrap",
              }}
            >
              {chipItems.map((chip) => (
                <Box
                  key={chip.key}
                  sx={{
                    minHeight: "21px",
                    paddingLeft: "10px",
                    paddingRight: "10px",
                    background: chip.bg,
                    borderRadius: "4px",
                    display: "inline-flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                  }}
                >
                  <Box
                    sx={{
                      textAlign: "center",
                      color: chip.color,
                      fontSize: "10px",
                      fontFamily: "Inter",
                      fontWeight: 700,
                      lineHeight: "14.7px",
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                    }}
                  >
                    {chip.label}
                  </Box>
                </Box>
              ))}
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
}

export default LandingFeaturedJobs;
